import { defineStore } from "pinia";
import { reactive, ref } from "vue";

export const ScrapingStore = defineStore('scraping', () => {
/***********************************************************************************************************/
/*                                             S T A T E                                                   */
/***********************************************************************************************************/
    const pageTitle = ref<string>('');
    const serviceName = ref<string>('');

    const scrapingReq = reactive<ScrapingReq>(
        {
            receiptId: '',
            loginTypeLevel: -1,
            name: '',
            birth: '',
            identity: '',
            telecom: '',
            phoneNo: ''
        }
    );

    const isLoading = ref<boolean>(false);
    const loadingText = ref<string>('30초 안에 모두 끝나요.<br/>잠시만 기다려 주세요.');

/***********************************************************************************************************/
/*                                            A C T I O N                                                  */
/***********************************************************************************************************/
   

/***********************************************************************************************************/
/*                                            G E T T E R                                                  */
/***********************************************************************************************************/


/***********************************************************************************************************/
/*                                            R E T U R N                                                  */
/***********************************************************************************************************/
    return { scrapingReq, pageTitle, serviceName, isLoading, loadingText }

})